import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['content']
  static values = {
    href: String,
    disabledClass: String,
    loadingClass: String
  }

  connect() {
    // A link styled as a button (role="button") should mimic native button
    // semantics: activate on Space (anchors only do Enter), and show a loading
    // state when activated.
    if (this.element.getAttribute('role') === 'button') {
      this.element.addEventListener('keydown', this.activateOnSpace)
      this.element.addEventListener('click', this.activate)
    }
  }

  disconnect() {
    this.element.removeEventListener('keydown', this.activateOnSpace)
    this.element.removeEventListener('click', this.activate)
  }

  activateOnSpace = (e) => {
    if (e.key === ' ' || e.key === 'Spacebar') {
      e.preventDefault() // stop the page from scrolling
      this.element.click()
    }
  }

  // Mirrors ui--button#onSubmit: show the loading state when the link is activated.
  activate = (e) => {
    if (e.defaultPrevented) return

    const disableWith = this.element.getAttribute('data-disable-with')
    if (disableWith) {
      this.setContent({ detail: { content: disableWith } })
    }
    if (this.hasLoadingClassValue) {
      this.element.classList.add(this.loadingClassValue)
    }
    // Defer disabling: disable() strips the href, and doing that synchronously
    // would cancel Turbo's data-turbo-method navigation on this same click.
    setTimeout(this.disable)
  }

  enable = () => {
    this.element.setAttribute('href', this.hrefValue)
    this.element.classList.remove(this.disabledClassValue)
    if (this.hasLoadingClassValue) {
      this.element.classList.remove(this.loadingClassValue)
    }
  }

  disable = () => {
    this.element.removeAttribute('href')
    this.element.classList.add(this.disabledClassValue)
  }

  setContent = (e) => {
    if (this.hasContentTarget) {
      this.contentTarget.innerHTML = e.detail.content
    } else {
      this.element.innerHTML = e.detail.content
    }
  }
}
